module.exports = __webpack_public_path__ + "static/media/clothing.adeb83f9.svg";